import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Col, Form, FormGroup, FormControl, Glyphicon, ControlLabel, Button, Checkbox } from 'react-bootstrap'
import Api from '../../../Global/Modules/Api'

const FETCH_URL = "api/companies/admin"

class BedrijvenEdit extends Component {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.emptyForm = this.emptyForm.bind(this)
        this.state = this.getInitialState()
    }
    getInitialState = () => {
        return {
            data: {
                id: this.props.id,
                name: "",
                city: "",
                zipCode: "",
                address: "",
                phone: "",
                invoiceCity: "",
                invoiceZipCode: "",
                invoiceAddress: "",
                invoiceEmail: "",
                website: "",
                url: "",
                single: false,
                searchWord: "",
                engineering: false,
                executive: false
            },
            errors: {}
        }
    }
    emptyForm() {
        this.setState(this.getInitialState())
        this.fileInput.value = ""
    }
    handleDelete = id => event => {
        event.preventDefault()
        const FETCH_URL_DELETE = `${FETCH_URL}/logo/${id}`
        if (window.confirm('Are you sure you wish to delete this logo?')) {
            Api.DeleteApi(FETCH_URL_DELETE).then(response => {
                window.location.href = '/admin/bedrijven/bewerken/' + id
            })
        }
    }
    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()

        var formData = new FormData()
        Object.keys(this.state.data).forEach(e => {
            formData.append(e, this.state.data[e])
        })

        const file = this.fileInput.files[0]
        formData.append('file', file === undefined ? null : file)

        Api.PostApiWithFile(FETCH_URL, formData, this.props.history)
            .then(response => {
                alert("Bedrifj updated")
                window.location.href = '/admin/bedrijven/'
            })
    }

    // Function to manage the changes of the text fields and selects
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        this.setState({ data: { ...this.state.data, [name]: value } })
    }

    getCompanyDetail(id) {
        let fetchUrl = `${FETCH_URL}/${id}`
        Api.GetApi(fetchUrl, this.props.history).then(company => {
            Api.print(`Detail of company ${id}`)
            Api.print(company)
            Api.print("----------")


            if (company !== undefined)
                this.setState({
                    data: {
                        ...this.state.data,
                        id: company.id,
                        name: company.name,
                        city: company.city,
                        searchWord: company.searchWord,
                        zipCode: company.zipCode,
                        address: company.address,
                        single: company.single,
                        invoiceCity: company.invoiceCity,
                        invoiceZipCode: company.invoiceZipCode,
                        invoiceAddress: company.invoiceAddress,
                        invoiceEmail: company.invoiceEmail,
                        phone: company.phone,
                        website: company.website,
                        logo: company.logo,
                        engineering: company.engineering,
                        executive: company.executive
                    }
                })

        })
    }

    componentDidMount() {
        this.getCompanyDetail(this.props.id)
    }

    render() {
        let data = this.state.data
        let errors = this.state.errors
        return (
            <div>
                <Form horizontal onSubmit={this.handleSubmit}>
                    <FormGroup controlId="BedrijfBewerkenNaam">
                        <Col componentClass={ControlLabel} sm={4}>
                            Naam
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="name" value={data.name} onChange={this.handleChange} required />
                            {Api.showError(errors, "name")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfBewerkenPlaats">
                        <Col componentClass={ControlLabel} sm={4}>
                            Plaats
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="city" value={data.city} onChange={this.handleChange} required />
                            {Api.showError(errors, "city")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfBewerkenPostcode">
                        <Col componentClass={ControlLabel} sm={4}>
                            Postcode
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="zipCode" value={data.zipCode} onChange={this.handleChange} required />
                            {Api.showError(errors, "zipCode")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfBewerkenBezoekadres">
                        <Col componentClass={ControlLabel} sm={4}>
                            Bezoekadres
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="address" value={data.address} onChange={this.handleChange} required />
                            {Api.showError(errors, "address")}
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="BedrijfToevoegenInvoicePlaats">
                        <Col componentClass={ControlLabel} sm={4}>
                            Plaats factuur
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="invoiceCity" value={data.invoiceCity} onChange={this.handleChange} />
                            {Api.showError(errors, "invoiceCity")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfToevoegenInvoicePostcode">
                        <Col componentClass={ControlLabel} sm={4}>
                            Postcode factuur
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="invoiceZipCode" value={data.invoiceZipCode} onChange={this.handleChange} />
                            {Api.showError(errors, "invoiceZipCode")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfToevoegenInvoiceadres">
                        <Col componentClass={ControlLabel} sm={4}>
                            Adres factuur
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="invoiceAddress" value={data.invoiceAddress} onChange={this.handleChange} />
                            {Api.showError(errors, "invoiceAddress")}
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="BedrijfToevoegenInvoiceemail">
                        <Col componentClass={ControlLabel} sm={4}>
                            E-mail factuur
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="invoiceEmail" value={data.invoiceEmail} onChange={this.handleChange} />
                            {Api.showError(errors, "invoiceEmail")}
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="BedrijfBewerkenTelefoon">
                        <Col componentClass={ControlLabel} sm={4}>
                            Telefoon
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="phone" value={data.phone} onChange={this.handleChange} required />
                            {Api.showError(errors, "phone")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfBewerkenWebsite">
                        <Col componentClass={ControlLabel} sm={4}>
                            Website
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="website" value={data.website} onChange={this.handleChange} required />
                            {Api.showError(errors, "website")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfBewerkensearchWord">
                        <Col componentClass={ControlLabel} sm={4}>
                            Zoekwoord
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="searchWord" value={data.searchWord} onChange={this.handleChange} />
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfBewerkenDocument">
                        <Col componentClass={ControlLabel} sm={4}>
                            Logo
                                </Col>
                        <Col sm={6}>
                            <div style={{ padding: "2px", height: "auto", width: "100px" }}>{data.logo === "/companies/" ? "No logo" : <img src={Api.Url + data.logo} alt={"Logo van " + data.name} className="img-responsive" style={{ display: "initial" }} />}</div>
                            {data.logo === "/companies/" ? "" : <Button bsSize="xsmall" className="delete" onClick={this.handleDelete(data.id)}><Glyphicon glyph="remove" /></Button>}
                            <FormControl type="File" inputRef={input => this.fileInput = input} />
                            {Api.showError(errors, "file")}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BedrijfBewerkenOpties">
                        <Col componentClass={ControlLabel} sm={4}>
                            Opties
                        </Col>
                        <Col sm={6}>
                            <Checkbox name="executive" checked={data.executive} onChange={this.handleChange}>Uitvoerend bedrijf</Checkbox>
                            <Checkbox name="engineering" checked={data.engineering} onChange={this.handleChange}>Ingenieursbedrijf</Checkbox>
                            <Checkbox name="single" checked={data.single} onChange={this.handleChange}>Zelfstandige</Checkbox>
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col sm={12}>
                            <LinkContainer to="/admin/bedrijven"><Button type="button" className="pull-left">Annuleren</Button></LinkContainer>
                            <Button type="submit" className="pull-right">Toevoegen</Button>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

export default BedrijvenEdit;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Bedrijven/Edit.js